import { today } from "@repo/helpers";
import { Complaint, ComplaintOrIncident, IncidentStatus } from "@repo/models";
import { EditableGridPage } from "@repo/ui";
import { useCallback } from "react";

import { useComplaintQueries } from "../../api/complaintApi";
import { ComplaintProvider, useComplaintContext, useRepContext } from "../../contexts/editableItemContext";
import { usePermissionsCheck } from "../../helpers/permissions";
import { useEntityId, useUpdateRoute } from "../../helpers/urlHooks";
import EditorDynamic from "./editor";
import GridBasic from "./grid";

function Complaints() {
	return (
		<ComplaintProvider>
			<ComplaintsInternal />
		</ComplaintProvider>
	);
}

function ComplaintsInternal() {
	const { repId } = useRepContext();
	const { overwriteItem, pendingChanges } = useComplaintContext();
	const { useComplaintQuery } = useComplaintQueries();
	const { data, loaded } = useComplaintQuery();
	const entityId = useEntityId();
	const updateRoute = useUpdateRoute();

	const { fullAPReadOnly } = usePermissionsCheck();

	const handleOpen = useCallback(function (item: Complaint) {
		overwriteItem(item);
	}, []);

	const newItem = useCallback(() => {
		overwriteItem({
			representativeId: repId,
			status: IncidentStatus.Open,
			statusId: IncidentStatus.Open,
			complaintOrIncident: ComplaintOrIncident.Incident,
			complaintOrIncidentId: ComplaintOrIncident.Incident,
			incidentDate: today(),
		} as Complaint);
	}, [overwriteItem, repId]);

	return (
		<EditableGridPage<Complaint>
			id="ComplaintContainer"
			items={data}
			keyProperty="id"
			Editor={EditorDynamic}
			Grid={GridBasic}
			openItem={handleOpen}
			pendingChanges={pendingChanges}
			newItem={newItem}
			itemsLoaded={loaded}
			noAutoOpen={!repId}
			entityId={entityId}
			updateRoute={updateRoute}
			fullReadOnly={fullAPReadOnly}
		/>
	);
}

export default Complaints;
